// eslint-disable-next-line no-restricted-imports
import type { EmotionCache } from '@emotion/cache';
// eslint-disable-next-line no-restricted-imports
import createCache from '@emotion/cache';
// eslint-disable-next-line no-restricted-imports
import { CacheProvider as EmotionCacheProvider } from '@emotion/react';
import '@iheartjane/reefer/styles/index.css';
import type { PropsWithChildren } from 'react';
import { useState } from 'react';
import root from 'react-shadow';

import './shadow-styles.css';

const ShadowRootDiv = root['div'];

const ShadowRoot = ({ children }: PropsWithChildren) => {
  const [emotionCache, setEmotionCache] = useState<EmotionCache | null>(null);

  function setEmotionStyles(ref: HTMLDivElement) {
    if (ref && !emotionCache) {
      const createdEmotionWithRef = createCache({
        key: 'css',
        container: ref,
      });
      setEmotionCache(createdEmotionWithRef);
    }
  }

  return (
    <ShadowRootDiv id="shadow-host">
      <style>{SHADOW_STYLE}</style>
      <div ref={setEmotionStyles} id="shadow-emotion">
        {emotionCache && (
          <EmotionCacheProvider value={emotionCache}>
            {
              // Modals and popovers go into this element. For accessibility reasons
              // the modals should not "portal" into the app itself but into
              // a sibling according to react-modal:
              // See https://reactcommunity.org/react-modal/#using-a-custom-parent-node
            }
            <div id="shadow-app-sibling"></div>
            <div id="shadow-app">{children}</div>
          </EmotionCacheProvider>
        )}
      </div>
    </ShadowRootDiv>
  );
};

export default ShadowRoot;
